import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { RootState } from "../ReduxToolkit/Store";
import { logout } from "../ReduxToolkit/Reducers/auth";
import { toast } from "react-toastify";

const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

function isSessionExpired(
  lastLogin: string | number | null | undefined,
): boolean {
  if (!lastLogin) return true;
  const lastLoginTime =
    typeof lastLogin === "number" ? lastLogin : new Date(lastLogin).getTime();
  if (Number.isNaN(lastLoginTime)) return true;
  return Date.now() - lastLoginTime > SEVEN_DAYS_MS;
}

export default function PrivateRoutes() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, user } = useSelector(
    (state: RootState) => state.auth,
  );

  useEffect(() => {
    if (!isAuthenticated || !user) return;
    if (isSessionExpired(user.last_login)) {
      dispatch(logout());
      localStorage.clear();
      navigate("/login", { replace: true });
      toast.error("Session expired. Please login again.");
    }
  }, [isAuthenticated, user, dispatch, navigate]);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
